// extracted by mini-css-extract-plugin
module.exports = {"introduce_container":"Introduce_introduce_container__n-DWM","main_container":"Introduce_main_container__mzc2o","title":"Introduce_title__3RYQx"};